import { Cascader, type CascaderProps } from 'antd'
import { REGION_OPTIONS } from '@/features/master-data/const/regions.ts'
import type { RegionOption } from '@/features/master-data/types/region.ts'

export function RegionCascader(props: Pick<CascaderProps<RegionOption>, 'disabled' | 'onChange' | 'value'>) {
  const options = REGION_OPTIONS

  return (
    <Cascader
      {...props}
      className="w-full"
      options={options}
      placeholder="请选择省、市、区县"
      showSearch={{
        filter: (inputValue, path) =>
          path.some((option) => String(option.label).toLowerCase().includes(inputValue.trim().toLowerCase()))
      }}
    />
  )
}

export type { RegionSnapshot } from '@/features/master-data/types/region.ts'
